var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCombinedTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M9.346 10.547a1.2 1.2 0 0 1 1.2-1.2h8.513a1.2 1.2 0 0 1 1.2 1.2v20.64a1.2 1.2 0 0 1-1.2 1.2h-8.513a1.2 1.2 0 0 1-1.2-1.2v-20.64ZM21.473 10.547a1.2 1.2 0 0 1 1.2-1.2h8.513a1.2 1.2 0 0 1 1.2 1.2v8.513a1.2 1.2 0 0 1-1.2 1.2h-8.513a1.2 1.2 0 0 1-1.2-1.2v-8.513ZM21.473 26.93a5.457 5.457 0 1 1 10.913 0 5.457 5.457 0 0 1-10.913 0ZM11.316 2.703a1.667 1.667 0 0 1 1.66-1.516h3.622c.862 0 1.582.657 1.66 1.516l.364 4a1.667 1.667 0 0 1-1.66 1.817h-4.35c-.98 0-1.748-.841-1.66-1.817l.364-4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M12.611 1.853c-.457 0-.876.259-1.08.668l-.149.297a.667.667 0 1 1-1.192-.596l.148-.297A2.542 2.542 0 0 1 12.611.52h4.35c.962 0 1.842.544 2.273 1.405l.148.297a.667.667 0 1 1-1.192.596l-.149-.297a1.208 1.208 0 0 0-1.08-.668h-4.35Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M11.316 39.031a1.667 1.667 0 0 0 1.66 1.516h3.622c.862 0 1.582-.657 1.66-1.516l.364-4a1.667 1.667 0 0 0-1.66-1.817h-4.35c-.98 0-1.748.841-1.66 1.817l.364 4Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M12.611 39.88c-.457 0-.876-.259-1.08-.668l-.149-.297a.667.667 0 1 0-1.192.596l.148.297a2.542 2.542 0 0 0 2.273 1.405h4.35c.962 0 1.842-.544 2.273-1.405l.148-.297a.667.667 0 1 0-1.192-.596l-.149.297c-.204.41-.623.668-1.08.668h-4.35Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M2.516 17.938A1.667 1.667 0 0 1 1 16.278v-3.622c0-.863.657-1.582 1.516-1.66l4-.364a1.667 1.667 0 0 1 1.817 1.66v4.35c0 .98-.841 1.748-1.817 1.66l-4-.364Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M1.667 16.641c0 .458.259.876.668 1.08l.297.15a.667.667 0 0 1-.596 1.192l-.297-.149a2.542 2.542 0 0 1-1.405-2.273v-4.349c0-.963.544-1.843 1.405-2.273l.297-.149a.667.667 0 0 1 .596 1.193l-.297.148c-.41.205-.668.623-.668 1.081v4.349Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.031 17.938a1.667 1.667 0 0 0 1.516-1.66v-3.622c0-.863-.657-1.582-1.516-1.66l-4-.364a1.667 1.667 0 0 0-1.817 1.66v4.35c0 .98.841 1.748 1.817 1.66l4-.364Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M39.88 16.641c0 .458-.259.876-.668 1.08l-.297.15a.667.667 0 0 0 .596 1.192l.297-.149a2.542 2.542 0 0 0 1.405-2.273v-4.349c0-.963-.544-1.843-1.405-2.273l-.297-.149a.667.667 0 0 0-.596 1.193l.297.148c.409.205.668.623.668 1.081v4.349Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M2.516 29.751A1.667 1.667 0 0 1 1 28.091v-3.623c0-.861.657-1.581 1.516-1.66l4-.363a1.667 1.667 0 0 1 1.817 1.66v4.35c0 .98-.841 1.748-1.817 1.66l-4-.364Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M1.667 28.454c0 .458.259.877.668 1.081l.297.149a.667.667 0 1 1-.596 1.192l-.297-.148a2.542 2.542 0 0 1-1.405-2.274v-4.349c0-.962.544-1.842 1.405-2.273l.297-.148a.667.667 0 1 1 .596 1.192l-.297.149c-.41.204-.668.623-.668 1.08v4.35Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.031 29.751a1.667 1.667 0 0 0 1.516-1.66v-3.623c0-.861-.657-1.581-1.516-1.66l-4-.363a1.667 1.667 0 0 0-1.817 1.66v4.35c0 .98.841 1.748 1.817 1.66l4-.364Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M39.88 28.454c0 .458-.259.877-.668 1.081l-.297.149a.667.667 0 1 0 .596 1.192l.297-.148a2.542 2.542 0 0 0 1.405-2.274v-4.349c0-.962-.544-1.842-1.405-2.273l-.297-.148a.667.667 0 1 0-.596 1.192l.297.149c.409.204.668.623.668 1.08v4.35Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M23.796 2.703a1.667 1.667 0 0 1 1.66-1.516h3.623c.862 0 1.582.657 1.66 1.516l.363 4a1.667 1.667 0 0 1-1.66 1.817h-4.35c-.98 0-1.748-.841-1.66-1.817l.364-4Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M25.092 1.853c-.458 0-.876.259-1.08.668l-.15.297a.667.667 0 0 1-1.192-.596l.149-.297A2.542 2.542 0 0 1 25.092.52h4.349c.963 0 1.843.544 2.273 1.405l.149.297a.667.667 0 1 1-1.193.596l-.148-.297a1.208 1.208 0 0 0-1.081-.668h-4.35Z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M23.796 39.031a1.667 1.667 0 0 0 1.66 1.516h3.623c.862 0 1.582-.657 1.66-1.516l.363-4a1.667 1.667 0 0 0-1.66-1.817h-4.35c-.98 0-1.748.841-1.66 1.817l.364 4Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M25.092 39.88c-.458 0-.876-.259-1.08-.668l-.15-.297a.667.667 0 0 0-1.192.596l.149.297a2.542 2.542 0 0 0 2.273 1.405h4.349c.963 0 1.843-.544 2.273-1.405l.149-.297a.667.667 0 1 0-1.193-.596l-.148.297c-.205.41-.623.668-1.081.668h-4.35Z",
  clipRule: "evenodd"
})));
SvgCombinedTable.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgCombinedTable);
export default ForwardRef;